import React, { Suspense, lazy, useEffect, useState, useRef } from "react";
import { Box, CircularProgress, AppBar, Toolbar, Button } from "@mui/material";
import { DefaultLayout } from "../components/_layout";
import Loader from "../components/_default/Loader";
import siteData from "../_data";
import HeaderSection from "../components/_default/HeadSection";
// https://www.manipal.edu/mu/news-events.html#/page/1

const Title = "News and Events";
// Lazy load components
const NewsAndEvents = lazy(() => import("../components/_pages/News/index"));

// Sections configuration
const sections = [
  { id: "news", label: "News and Events", Component: NewsAndEvents },
];

const NewsPage = () => {
  const [visibleSections, setVisibleSections] = useState({});
  const sectionRefs = useRef({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => ({
              ...prev,
              [entry.target.id]: true,
            }));
            observer.unobserve(entry.target); // Stop observing once it's visible
          }
        });
      },
      { threshold: 0.1 } // Adjust when the component is considered visible (10% here)
    );

    Object.keys(sectionRefs.current).forEach((id) => {
      if (sectionRefs.current[id]) {
        observer.observe(sectionRefs.current[id]);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <DefaultLayout
      title={`${Title} | ${siteData.brand.name}`}
      description="Musa Institute for Academic and Skills Development "
      isFooterHome={false}
    >
      <Box
        style={{
          position: "relative",
          padding: "0px",
          margin: "0px",
          width: "100%",
        }}
      >
        <HeaderSection title={Title} />
        {sections.map(({ id, Component }) => (
          <Box
            key={id}
            id={id}
            ref={(el) => (sectionRefs.current[id] = el)}
            sx={{
              position: "relative",

              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {visibleSections[id] ? (
              <Suspense fallback={<Loader />}>
                <Component />
              </Suspense>
            ) : (
              <Loader />
            )}
          </Box>
        ))}
      </Box>
    </DefaultLayout>
  );
};

export default NewsPage;
